import { QueryKey } from '@tanstack/react-query';

import { NO_ROLE_ID } from '../api/portalGatewayClient';
import { useStore } from '../store';

export type RoleId = string;
type QueryKeyWithContext<K extends QueryKey> = [string, ...K];
export type QueryKeyWithRole<T extends QueryKey> = readonly [
  RoleId,
  ...QueryKeyWithContext<T>,
];

export const prependRoleId = <T extends QueryKey>(
  baseQueryKey: QueryKeyWithContext<T>
): QueryKeyWithRole<T> => {
  const role = useStore.getState().activeUserRole;
  const roleId = role?.id ?? NO_ROLE_ID;
  const [context, ...params] = baseQueryKey;
  return [roleId, context, ...params];
};

export const unwrapQueryKeyWithRole = <T extends QueryKey>(
  keyWithRole: QueryKeyWithRole<T>
) => {
  const [roleId, context, ...params] = keyWithRole;
  return {
    context,
    roleId,
    params,
  };
};
